"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var breakpoints = exports.breakpoints = [40, 52, 64];

var space = exports.space = [0, 8, 16, 32, 64];

exports.default = {
  breakpoints: breakpoints,
  space: space
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/reflexbox/dist/config.js
// module id = 215
// module chunks = 0